import { openSalesIQChat } from '../utils/openSalesIQChat';

const issues = [
  {
    title: 'Sync Problems',
    description: 'Device and cloud sync not matching up? We troubleshoot TreeVault and local sync paths.',
  },
  {
    title: 'Upgrade Failures',
    description: 'Install or update errors when moving to a newer FTM release—we walk you through recovery.',
  },
  {
    title: 'Missing Trees',
    description: 'Tree file vanished or won\'t open? We help locate backups and restore your genealogy work.',
  },
  {
    title: 'Broken Media Links',
    description: 'Photos or documents showing as missing? We reconnect attachments to the right people.',
  },
  {
    title: 'Display Issues',
    description: 'Layout glitches on desktop, laptop, or tablet—we fix view and rendering problems.',
  },
  {
    title: 'Edits Not Saving',
    description: 'Changes disappearing or failing to sync? We make sure updates stick across devices.',
  },
];

export default function SupportIssues() {
  return (
    <section className="t7-section t7-section--wash" id="support-issues">
      <div className="container">
        <div className="t7-head t7-head--rail">
          <p className="t7-kicker">Fix it fast</p>
          <h2 className="t7-title">Problems we solve every day</h2>
          <p className="t7-lead">
            From sync glitches to missing media—open chat and we will walk you to a working tree.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-8 md:mb-10">
          {issues.map((issue) => (
            <article
              key={issue.title}
              className="bg-white border border-[#c4d4ca] rounded-[10px] p-5 sm:p-6 md:p-7 hover:border-[#40916c] transition-colors shadow-sm"
            >
              <h3 className="font-serif text-lg sm:text-xl text-[#152019] mb-2">{issue.title}</h3>
              <p className="text-[#55665c] text-sm leading-relaxed m-0">{issue.description}</p>
            </article>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between border-t border-[#c4d4ca] pt-6 sm:pt-8">
          <p className="text-[#152019] font-medium m-0">Running into one of these right now?</p>
          <div className="t7-actions">
            <button type="button" className="t7-btn t7-btn--green sm:w-auto" onClick={openSalesIQChat}>
              Chat with Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
